import React, { useState, useCallback, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { getTemplateCategories } from "@/components/Joyspace/api/createmenu";
import { Template } from "@/components/Joyspace/types";
import "./index.less";
import { Collapse, Spin, Modal as antdModal, message } from "antd";
import Modal from "antd/lib/modal/Modal";
import { changeEgovUrl } from "@/utils/tools";
import cookies from "js-cookie";
import { FocusSDK, isFocusEnv, useDebounce } from "@/utils";
import Bus from "@/utils/bus";

export function AICreate(props: any) {
  const { onClose, callback, url } = props;
  const webviewRef = React.useRef<HTMLWebViewElement | null>(null);

  const [visible, setVisible] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const handleCancel = useDebounce(() => {
    antdModal.confirm({
      title: "确定退出吗？",
      content: "退出后，已生成的内容将会清空！",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        setVisible(false);
        setIsLoading(true);
        onClose?.();
      },
      onCancel: () => {
        return;
      }
    });
  }, 400);
  useEffect(() => {
    const handleClose = ({ path }: { path: string }) => {
      if (!path) return;
      setVisible(false);
    };
    FocusSDK.on("joypace:openFolder", handleClose);
    return () => {
      FocusSDK.off("joypace:openFolder", handleClose);
    };
  }, []);

  const newWindowCb = React.useCallback((e: any) => {
    window.open(e.url);
  }, []);
  const preloadjs = useMemo(() => {
    if (!isFocusEnv()) return "";
    return FocusSDK?.getInnerAppPreloadJSPath();
  }, []);
  const bindEventsCb = React.useCallback(() => {
    if (!webviewRef.current) return;
    const readyCb = () => {
      setIsLoading(false);
      // @ts-ignore
      FocusSDK.isBeta() && webviewRef.current?.openDevTools?.();
    };

    // webviewRef.current.removeEventListener("did-fail-load", failLoadCb);
    // webviewRef.current.addEventListener("did-fail-load", failLoadCb);

    // webviewRef.current.removeEventListener("did-navigate", onResponseCb);
    // webviewRef.current.addEventListener("did-navigate", onResponseCb);

    // webviewRef.current.removeEventListener("did-start-loading", onDidStartLoading);
    // webviewRef.current.addEventListener("did-start-loading", onDidStartLoading);

    // webviewRef.current.removeEventListener("did-stop-loading", onDidStopLoading);
    // webviewRef.current.addEventListener("did-stop-loading", onDidStopLoading);
    webviewRef.current?.removeEventListener("new-window", newWindowCb);
    webviewRef.current?.addEventListener("new-window", newWindowCb);
    webviewRef.current?.removeEventListener("dom-ready", readyCb);
    webviewRef.current?.addEventListener("dom-ready", readyCb);
    return () => {
      webviewRef.current?.removeEventListener("new-window", newWindowCb);
      webviewRef.current?.removeEventListener("new-window", newWindowCb);
    };
  }, []);

  return (
    <Modal
      visible={visible}
      className="joyspace-ai-create-modal"
      // width={950}
      style={{
        height: "100%"
      }}
      centered
      // @ts-ignore
      getContainer={document.getElementsByClassName("joyspace")?.[0] || document.body}
      onCancel={handleCancel}
      title={null}
      maskStyle={{ position: "absolute" }}
      wrapClassName="joyspace-ai-create-modal-wrap"
      footer={null}
      maskClosable={false}
    >
      {isLoading && (
        <div className="loading-container">
          <Spin
            spinning={true}
            // style={{
            //   width: "14px",
            //   height: "14px",
            //   lineHeight: "14px"
            // }}
          />
        </div>
      )}
      <webview
        ref={(ref) => {
          webviewRef.current = ref;
          bindEventsCb();
        }}
        onFocus={() => {}}
        style={{ width: "100%", height: "100%" }}
        id="AIJoyspace"
        src={changeEgovUrl(url)}
        // @ts-ignore
        allowpopups="true"
        preload={preloadjs}
        webpreferences="contextIsolation=no,sandbox=false"
        {...{
          partition: "persist:builtin-browser",
          disablewebsecurity: true
        }}
      />
      {/* {!isFocusEnv() && (
        <iframe
          ref={(ref) => {
            // webviewRef.current = ref;
            // bindEventsCb();
          }}
          onFocus={() => {}}
          style={{ width: "100%", height: "100%" }}
          id="AIJoyspace"
          src={changeEgovUrl("http://desktop.jdcloud.com:8710/ai-workspace-joyspace/ppt")}
          // @ts-ignore
          allowpopups="true"
          preload={preloadjs}
        />
      )} */}
    </Modal>
  );
}

export default async function openAICreateModal(props: any) {
  if (!isFocusEnv()) return;
  const { globalContext } = props;
  const { authInfo, appRuntimeEnv } = globalContext;
  const accessToken = FocusSDK.authInfo?.accessToken || cookies.get("focus-token");
  // const url = `http://desktop.jdcloud.com:8710/ai-workspace-joyspace/ppt`;
  const url = `${appRuntimeEnv.meMainEntry}/ai-workspace-joyspace`;
  console.log(url, "appRuntimeEnv1112");
  //   const cookiesArray = [
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-token",
  //       value: accessToken
  //     },
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-team-id",
  //       value: appRuntimeEnv.selectedTeamId
  //     },
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-lang",
  //       value: appRuntimeEnv.registryConfig.lang
  //     },
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-client",
  //       value: appRuntimeEnv.registryConfig.client
  //     },
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-app-id",
  //       value:
  //         FocusSDK.authInfo?.ddAppId ||
  //         cookies.get("focus-app-id") ||
  //         (window as any)?._BTS_CONFIG?.REACT_APP_DD_APPID ||
  //         process.env.REACT_APP_DD_APPID ||
  //         ""
  //     },
  //     {
  //       domain: appRuntimeEnv.domain,
  //       url,
  //       name: "focus-client",
  //       value: appRuntimeEnv.registryConfig.client
  //     }
  //   ];
  //   await FocusSDK.setBuiltInBrowserCookies(cookiesArray);
  // service.authService.exchangeWebToken().then((res) => {
  const focusToken = authInfo?.accessToken;
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function onClose() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<AICreate {...{ ...props, focusToken, onClose, url }} />, ele);
  // });
}
